/**
 * Asynchronously loads the component for UploadLeadsPage
 */

import { lazyLoad } from 'utils/loadable';

export const UploadLeadsPage = lazyLoad(
  () => import('./index'),
  module => module.UploadLeadsPage,
);
